import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BasicResult } from '../models/basic-result';
import { AuditCollectionResult } from '../models/Audits/audit-collection-result';
import { Campaign } from '../models/Campaigns/campaign';
import { CampaignReturn } from '../models/Campaigns/campaign-return';
import { CampaignListRequest } from '../models/Campaigns/campaign-list-request';
import { CampaignListResult } from '../models/Campaigns/campaign-list-result';
import { CampaignDetailResult } from '../models/Campaigns/campaign-detail-result';
import { EditAuditLocationResult } from '../models/Locations/edit-audit-location-result';
import { AuditLocationResult } from '../models/Locations/audit-location-result';
import { AuditSummaryResultRequest } from '../models/Audits/AuditResults/audit-summary-result-request';
import { CompletedCampaignResult } from '../models/Campaigns/completed-campaign-result';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditRequestsService {

  constructor(private httpClient: HttpClient) {

  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: "response" as "response",
    responseType: "json" as const,
    withCredentials: true
  };
  getAuditList(): Observable<AuditCollectionResult> {
    return this.httpClient.get<AuditCollectionResult>(`${environment.apiUrl}auditrequest/auditlist`, this.httpOptions).pipe(
      map((res:any) => {
        return new AuditCollectionResult(res.body!)
      })
    );
  }
  validateAuditRequest(request: Campaign): Observable<CampaignReturn> {
    return this.httpClient.post<Campaign>(`${environment.apiUrl}auditrequest/validaterequest`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new CampaignReturn(res.body!)
      })
    );
  }
  saveAuditCampaign(request: Campaign): Observable<BasicResult> {
    return this.httpClient.post<Campaign>(`${environment.apiUrl}auditrequest/saverequest`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  getCampaignList(request: CampaignListRequest): Observable<CampaignListResult> {
    return this.httpClient.post<CampaignListRequest>(`${environment.apiUrl}auditrequest/campaignlist`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new CampaignListResult(res.body!);
      })
    );
  }
  haltCampaign(request: Campaign): Observable<BasicResult> {
    return this.httpClient.post<number>(`${environment.apiUrl}auditrequest/stoprequest`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  getCampaignRecipients(campaign: Campaign): Observable<CampaignDetailResult> {
    return this.httpClient.post<number>(`${environment.apiUrl}auditrequest/getrecipients`, campaign, this.httpOptions).pipe(
      map((res:any) => {
        return new CampaignDetailResult(res.body!);
      })
    );
  }
  updateCampaign(campaign: Campaign): Observable<BasicResult> {
    return this.httpClient.post<Campaign>(`${environment.apiUrl}auditrequest/savecampaignupdate`, campaign, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  getCampaignLocations(isEdit: boolean): Observable<AuditLocationResult> {
    return this.httpClient.post<boolean>(`${environment.apiUrl}auditrequest/locationlist`, isEdit, this.httpOptions).pipe(
      map((res:any) => {
        return new AuditLocationResult(res.body!);
      })
    );
  }
  getCampaignResults(request: AuditSummaryResultRequest): Observable<CampaignListResult> {
    return this.httpClient.post<AuditSummaryResultRequest>(`${environment.apiUrl}auditrequest/getcampaignresults`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new CampaignListResult(res.body!);
      }))
  }
  getCampaignResult(campaignID: number): Observable<CompletedCampaignResult> {
    return this.httpClient.post<number>(`${environment.apiUrl}auditrequest/getcampaignresult`, campaignID, this.httpOptions).pipe(
      map((res:any) => {
        return new CompletedCampaignResult(res.body!);
      })
    );
  }
  getCampaignResultDetails(campaignResultID: number): Observable<CompletedCampaignResult> {
    return this.httpClient.post<number>(`${environment.apiUrl}auditrequest/getcampaignresultdetail`, campaignResultID, this.httpOptions).pipe(
      map((res:any) => {
        return new CompletedCampaignResult(res.body!);
      })
    );
  }

}
